import { Changelog } from "../../types";
import ChangelogItem from "./ChangelogsListItem";
import { ChangelogsContainer } from "./Changelogs.styled";
import { Helper } from "../../helper/helper";


const Changelogs = ({ changelogList }: { changelogList?: Changelog[] }) =>
  changelogList?.length ? (
    <ChangelogsContainer>
      {changelogList
        .sort((a, b) => (b.date !== a.date
          ? b.date.localeCompare(a.date)
          : Helper.getBuildNumber(b.version) - Helper.getBuildNumber(a.version)
        ))
        .map((data: Changelog, index: number) => ChangelogItem({ index, data }))}
    </ChangelogsContainer>
  ) : null;

export default Changelogs;
